import React, { useState, useEffect, useRef, useMemo, useCallback } from 'react';
import { Modal, Icon, Button, Spin, Table, message } from 'antd';
import request from 'request';
import serviceFeeFormat from 'serviceFeeFormat';
import extHandlers from '../extHandlers'
import styles from './style.scss?__local';

const feeTypeMap = {
  useTime: 1,
  useMoneny: 2,
}

const feeTextMap = {
  [feeTypeMap.useTime]: {
    content: `将根据使用该小程序的时长收取梯度服务费，当月服务费=当月该小程序使用时长对应的服务费，服务费将在次月月初结算，首次同意后次日生效。
    `,
  },
  [feeTypeMap.useMoneny]: {
    content: `将根据该小程序中产生的礼物流水收取梯度服务费，当月服务费=当月该小程序产生的礼物流水*对应区间费率，最高不超过封顶费用。服务费将在次月月初结算，首次同意后下场使用生效
    `,
  },
}

const installStateMap = {
  hadInstall: 1,
  unstall: 0,
}

const modalStateMap = {
  [installStateMap.unstall]: {
    title: '费用收取详情',
    okBtnText: '同意',
    cancelBtnText: '拒绝',
    desc: '',
  },
  [installStateMap.hadInstall]: {
    title: '费用变更详情',
    okBtnText: '同意变更',
    cancelBtnText: '拒绝并移除',
    desc: '注意本月服务费已变更，请详细阅读付费详情，以免造成您的财产损失',
  },
}

function ConfirmModal({data, onOk, onCancel, install}) {
  const {extUuid, hadInstall} = data;

  const handlers = extHandlers(data);

  const feeType = data.serviceFee.type;

  function handle(key) {
    const value = data[key]
    return handlers[key] ? handlers[key](value) : value
  }

  const [pending, setPending] = useState('')

  const handleAnswer = answer => {
    if (pending) {
      return
    }

    setPending(answer)

    let fetch = null

    if (answer == 'ok') {
      fetch = request({
        url: request.api.confirmExtensionFeeChange,
        type: 'POST',
        data: {
          extUuid,
          confirmType: answer == 'ok' ? 2 : 3,
        },
      })
    } else {
      const isFromFeeChangeConfirm = true;
      fetch = install.un(isFromFeeChangeConfirm);
    }

    fetch.done(() => {
      answer == 'ok' ? onOk() : onCancel()
    })
      .fail(err => message.error(`操作失败：${err}`))
      .always(() => setPending(''))
  }

  const currentModelContent = modalStateMap[+hadInstall];

  return (
    <Modal
      visible={true}
      title={currentModelContent.title}
      width={500}
      destroyOnClose={true}
      closable={false}
      maskClosable={false}
      footer={null}
    >
      {
        hadInstall &&
                <div className={styles['app-fee-tip']}>
                  {currentModelContent.desc}
                </div>
      }

      <div className={hadInstall ? styles['app-tip-wrapper'] : null}>
        <div className={styles['app-hd']}>
          <div className={styles['app-logo']}>
            <img src={ handle('extLogo') } />
          </div>

          <div className={styles['app-info']}>
            <div className={styles['app-name']}>
              { handle('extName') }
            </div>
            <div className={styles['app-brief']}>
              { handle('extBrief') }
            </div>
          </div>
        </div>

        <div className={styles['app-bd']}>
          <div className={styles['app-detail']}>
            <div className={styles['app-detail-name']}>
                            收取费用详情
            </div>

            <div className={styles['app-detail-desc']}>
              {feeTextMap[feeType].content}
            </div>

            <div className={styles['app-detail-content']}>
              {
                handle('serviceFee')
              }
            </div>
          </div>
        </div>

        <div className={styles['app-ft']}>
          <Button loading={pending == 'ok'} onClick={() => handleAnswer('ok')} type="primary">{currentModelContent.okBtnText}</Button>
          <Button loading={pending == 'cancel'} onClick={() => handleAnswer('cancel')}>{currentModelContent.cancelBtnText}</Button>
        </div>
      </div>
    </Modal>
  )
}

export default ConfirmModal;